<template>
	<div class="address" v-show="showAddress" @click.stop="close()">
		<div class="address-box" @click.stop="">
			<div class="title">

				<img class="sign decorate" src="../../assets/img/home/decorate-left.png" />
				&nbsp;&nbsp;个人信息&nbsp;&nbsp;
				<img class="sign decorate" src="../../assets/img/home/decorate-right.png" />
			</div>
			<div class="body">
				<div class="cell">
					<span class="label">收货人&nbsp;&nbsp;&nbsp; </span>
					<div class="input-box">
						<div class="input"><input v-model="form.consignee" /></div>
					</div>
				</div>

				<div class="cell">
					<span class="label">手机号码</span>
					<div class="input-box">
						<div class="input"><input v-model="form.consigneePhone" /></div>
					</div>
				</div>

				<div class="cell">
					<span class="label">所在地区</span>
					<div class="input-box">
						<div class="input"><input v-model="form.area" /></div>
					</div>
				</div>

				<div class="cell">
					<span class="label">详细地址</span>
					<div class="input-box">
						<div class="input"><input v-model="form.address" /></div>
					</div>
				</div>

			</div>
			<div class="foot">
				<div class="submit" @click="submit()">保 存</div>

			</div>
		</div>
	</div>
</template>

<script>
	import store from '@/store'
	export default {
		name: "Address",
		data() {
			return {
				form: {
					id: null,
					address: null,
					area: null,
					consignee: null,
					consigneePhone: null,
				},
				showAddress: false
			};
		},
		created() {},
		computed: {},
		methods: {
			show(form, callBack) {
				this.showAddress = true
				this.form = form
				document.body.appendChild(this.$el)
				this.submitCallBack = callBack
			},
			close() {
				this.showAddress = false
				document.body.removeChild(this.$el)
			},
			submitCallBack() {},
			async submit() {
				if (this.form.consigneePhone.length != 11) {
					return this.$Toast.show('手机号码出错')
				}
				let res = await store.dispatch('savePersnalInfo',this.form)
				if(this.$Api.ok(res)){
					this.$Toast.show('保存成功')
					this.close()
					this.submitCallBack()
				}
			}
		},
	};
</script>
<style scoped>
	input {
		background: none;
		outline: none;
		border: none;
		width: 100%;
	}

	.address {
		height: 100vh;
		width: 100vw;
		position: absolute;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.6);
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
	}

	.address-box {
		border-radius: 6px;
		width: 80%;
		margin: 0 auto;
		overflow: hidden;
		
	}

	.title {
		background-color: #ffffff;
		color: #686e3f;
		padding: 12px;
		font-size: 16px;
	}

	.decorate {
		width: 20%;
	}

	.logo {
		width: 140px;
	}

	.close-btn {
		width: 20px;
		float: right;
	}

	.body {
		background-color: #efe8c2;
		padding: 12px;
	}


	.foot {
		background-color: #ffffff;
		color: #686e3f;
		padding: 16px;
	}

	.submit {
		background-color: #90ba89;
		width: 40%;
		color: white;
		border-radius: 50px;
		margin: 0 auto;
		padding: 6px;
	}

	.cell {
		display: flex;
		padding: 4px 8px;
	}

	.cell .input-box {
		flex: 1;
		background-color: #ffffff;
		border-radius: 60px;
		text-align: left;
		display: flex;
		justify-content: flex-start;
		padding: 4px 12px;
	}

	.cell .input-box img {
		width: 16px;
		vertical-align: middle;
	}

	.cell .label {
		line-height: 18px;
		height: 18px;
		padding: 4px 12px;
		color: #686e3f;
	}

	.cell .input-box .input {
		vertical-align: middle;
		border: none;
		flex: 1;
		padding: 2px 6px;
		display: block;
	}

	.code {
		width: auto;
		display: inline-block;
		background-color: #dcce6b;
		border-radius: 60px;
		color: #ffffff;
		line-height: 28px;
		vertical-align: middle;
		text-align: center;
		margin-left: 10px;
		padding: 0 10px;
		font-size: 12px;
	}
</style>
